import { Injectable } from "@angular/core";

@Injectable()
export class ErrorLogService {
    // logging errors
    logError(_error: any) {
        // will be logging errors here
        // once service is confirmed from allianz
    }
}